<template>
  <custom-dialog class="close-order-dialog" :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
        <!-- <el-row>
          <el-col> -->
            <el-form-item :label="$t('close_order_dialog.qu_xiao_yuan_yin')" prop="opinion">
              <el-input v-model="form.opinion" type="textarea" :rows="2" class="detail-address"></el-input>
            </el-form-item>
          <!-- </el-col>
        </el-row> -->
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" plain @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  computed: {
    rules() {
      return {
        opinion: {
          required: true,
          message: this.$t('Common.com_required'),
        }
      };
    }
  },
  data() {
    return {
      form: {
        opinion: '',
      }
    };
  },
  mounted() {},
  methods: {
    getReqData() {
      const data = this.model.data;
      return {
        caseOrderId: data.caseOrderId,
        caseOrderState: 110,
        orderCloseReason: this.form.opinion,
      };
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const reqUrl = apis.caseOrderUpdateState;
          const reqData = this.getReqData();
          this.$postJSON(reqUrl, reqData, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.closeDialog();
            this.$emit('success', this.form.opinion);
          });
        }
      });
    },
  }
};
</script>

<style lang="scss">
.close-order-dialog {
}
</style>
